export function loginRequestBody(loginData, extra = {}) {
  const body = {
    email: loginData.email,
    ...extra,
  }
  if (loginData.developerMode) {
    body.actorEmail = loginData.actorEmail
    body.actorPassword = loginData.actorPassword
    return body
  }
  body.password = loginData.password
  return body
}

export function applyDeveloperAccess(mainStore, data) {
  const allowed = data?.developerAccess === true
  mainStore.developerAccess = allowed
  if (!allowed) {
    mainStore.isDevLoggedIn = false
    mainStore.isInDevMode = false
    return
  }
  const impersonating = data?.impersonating === true
  mainStore.isDevLoggedIn = impersonating
  if (data?.developerMode === true) {
    mainStore.isInDevMode = true
  }
}
